import { render, staticRenderFns } from "./ConfiguracoesGerais.vue?vue&type=template&id=7401fd2a&scoped=true&"
import script from "./ConfiguracoesGerais.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesGerais.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesGerais.vue?vue&type=style&index=0&id=7401fd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7401fd2a",
  null
  
)

export default component.exports